import MoveTo from 'moveto';

export default class Floating {
  constructor() {
    const moveTo = new MoveTo();

    Array.from(document.querySelectorAll('a[href^="#"]'),  trigger => {
      moveTo.registerTrigger(trigger);
    });
  }
}
